module.exports = __webpack_public_path__ + "static/christian-black-tee-341defff757f4342e0f1dfa7e220217a.png";